import { useQuery } from "@tanstack/react-query";
import { fetchWebhookHistory } from "../api/fetchWebhookHistory";

export const useWebhookHistory = (companyId, limit = 50, offset = 0, enabled = true) => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["webhookHistory", companyId, limit, offset],
    queryFn: () => fetchWebhookHistory(companyId, limit, offset),
    enabled: !!companyId && enabled,
  });

  return {
    data: data?.result || null,
    error,
    isLoading,
    refetch,
  };
};
